import axios from "axios";
import { useEffect, useState } from "react";

export default function useEditorDashboard() {

    const [tab, setTab] = useState('queue');     // 'queue' | 'completed'
    const [dashboard, setDashboard] = useState();
    const [queue, setQueue] = useState();
    const [completed, setCompleted] = useState();

    // Header statistiche (medio oggi / consegnati oggi / % entro soglia + sla)
    useEffect(() => {
        axios.get('stats/editor-dashboard')
            .then(res => setDashboard(res.data));
    }, []);

    // Tab "Da editare": coda lavori
    useEffect(() => {
        if (tab !== 'queue') return;
        setQueue();
        axios.get('stats/editor-queue')
            .then(res => setQueue(res.data));
    }, [tab]);

    // Tab "Completati": task DONE dell'editor (timeline calcolata client-side)
    useEffect(() => {
        if (tab !== 'completed') return;
        setCompleted();
        axios.get('tasks', { params: { index_role: 'editor', status: 'DONE' } })
            .then(res => setCompleted(res.data));
    }, [tab]);

    return { tab, setTab, dashboard, queue, completed };
}
